<template>
    <Transition name="fade-scale" mode="out-in">
        <slot></slot>
    </Transition>
</template>

<style lang="scss">

    .fade-scale-enter-active,
    .fade-scale-leave-active 
    {
        transition: all 500ms ease;
        opacity: 1;
        transform: scale( 1 );
    }

    .fade-scale-enter-from,
    .fade-scale-leave-to 
    {
        opacity: 0;
        transform: scale( 0.9 );
    }

</style>